/*
 * Sneakies — cart drawer quantity and removal.
 *
 * Only the controls in our own drawer contents need this
 * (snippets/sn-cart-line-items.liquid). Everything else about the drawer — the
 * dialog, opening on add-to-cart, the scroll lock, focus handling and the count
 * bubble — stays the theme's, which is why this file is short.
 *
 * The update path deliberately goes through Shopify and back rather than
 * patching the DOM: POST /cart/change.js, then dispatch the theme's own
 * `cart:update` event so the theme re-renders the drawer section from the server.
 * That keeps one source of truth for prices, discounts and totals — the cart —
 * and means the pre-order discount and the plan panel recompute in Liquid
 * instead of being recalculated here in a second, divergent implementation.
 */
(function () {
  var BUSY = 'aria-busy';

  function drawerRoot() {
    return document.querySelector('.cart-drawer');
  }

  function setBusy(on) {
    var root = drawerRoot();
    if (!root) return;
    ['.sn-cd-items', '.sn-cd-summary', '.sn-cd-footer'].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) el.setAttribute(BUSY, on ? 'true' : 'false');
    });
  }

  /*
   * The theme's own event classes live in an ES module (assets/events.js) that
   * this plain script cannot import, so the event is constructed by name.
   * 'cart:update' is the string the theme dispatches and listens for
   * (ThemeEvents.cartUpdate), and its cart-items component re-renders on it.
   *
   * The detail must MATCH the theme's CartUpdateEvent shape:
   * { resource, sourceId, data: { ..., sections } }. The first version sent
   * { source } with no `data`, and the theme's handler reads
   * `event.detail.data.sections` unguarded — it threw on the missing object
   * and died BEFORE its renderSection fallback, so quantity changes and
   * removals updated the server but never the screen (found by the post-merge
   * mobile audit). `sections` carries the drawer section's fresh HTML, which
   * /cart/change.js renders in the same round trip when asked.
   */
  function announceCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart || {},
        sourceId: 'sn-cart-drawer',
        data: {
          source: 'sn-cart-drawer',
          itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : undefined,
          sections: (cart && cart.sections) || {}
        }
      }
    }));
  }

  function drawerSectionId() {
    var el = document.querySelector('cart-items-component');
    return (el && el.dataset && el.dataset.sectionId) || '';
  }

  function change(key, quantity) {
    setBusy(true);
    var body = { id: key, quantity: quantity };
    var sectionId = drawerSectionId();
    if (sectionId) body.sections = sectionId;
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/change.js'
        : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/change ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        announceCartUpdate(cart);
      })
      .catch(function () {
        /*
         * Reload rather than leave stale numbers on screen. A cart that shows one
         * total and charges another is worse than a flicker, and this path only
         * runs when Shopify has already refused the change.
         */
        window.location.reload();
      })
      .then(function () {
        setBusy(false);
      });
  }

  /*
   * Delegated from the document, because the theme replaces the drawer's inner
   * HTML wholesale on every cart update — anything bound to the buttons
   * themselves would be discarded on the first change.
   */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-sn-cd-qty]');
    if (step) {
      if (step.disabled) return;
      e.preventDefault();
      change(step.getAttribute('data-sn-cd-qty'), parseInt(step.getAttribute('data-sn-cd-to'), 10) || 0);
      return;
    }

    var remove = e.target.closest('[data-sn-cd-remove]');
    if (remove) {
      e.preventDefault();
      change(remove.getAttribute('data-sn-cd-remove'), 0);
    }
  });
})();
